import React from 'react';
import { marked } from 'marked';
import i18next from 'i18next';
import Modal from '../../../StyledComponents/Modal';
import Content from '../../../StyledComponents/Content';
import { Repeat } from '../../../StyledComponents/Repeat';
import { ButtonInline } from '../../../StyledComponents/Button';
import LogoBox from '../../../StyledComponents/LogoBox';
import { InsuranceOption } from '../../../@types/codegen/types';

interface InsuranceFreeModal {
  onClose: () => void;
  insuranceOptions: InsuranceOption;
}

const InsuranceFreeModal = ({ onClose, insuranceOptions }: InsuranceFreeModal) => {
  return (
    <Modal
      title={insuranceOptions?.insuranceHeader ?? i18next.t('item.insurance')}
      onClose={onClose}
    >
      {insuranceOptions?.longDescription && (
        <Repeat>
          <Content
            dangerouslySetInnerHTML={{
              __html: marked(insuranceOptions.longDescription),
            }}
          ></Content>
        </Repeat>
      )}
      {insuranceOptions?.url && (
        <Repeat>
          <ButtonInline
            as="a"
            href={insuranceOptions.url}
            title={i18next.t('item.readMoreAboutInsuranceInNewTab') || ''}
            target="_blank"
            rel="noopener noreferrer"
          >
            {i18next.t('item.readMoreAboutInsuranceInNewTab')}
          </ButtonInline>
        </Repeat>
      )}
      {insuranceOptions?.logotype && (
        <Repeat>
          <LogoBox
            logo={insuranceOptions.logotype}
            alt={insuranceOptions.name || i18next.t('common.logotype') || ''}
            wide
          />
        </Repeat>
      )}
    </Modal>
  );
};

export default InsuranceFreeModal;
